<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/marine-layer/products/*', { eager: true });

useHead({});

const products = [
	{
		title: "Corbet Full Zip Vest",
		src: imagesGlob["../../images/brands/marine-layer/products/swaggerproductpagewebsiteproductsml3corbet-full-zip-vest.png"].default
	},
	{
		title: "Signature Crew",
		src: imagesGlob["../../images/brands/marine-layer/products/swaggerproductpagewebsiteproductsml6signature-crew.png"].default
	},
	{
		title: "Corbet Quilted Reversible Pullover",
		src: imagesGlob["../../images/brands/marine-layer/products/swaggerproductpagewebsiteproductsml5corbet-quilted-reversible-pullover.png"].default
	},
	{
		title: "Weekender Bag",
		src: imagesGlob["../../images/brands/marine-layer/products/swaggerproductpagewebsiteproductsml9weekender-bag.png"].default
	},
	{
		title: "Signature Lined Blanket",
		src: imagesGlob["../../images/brands/marine-layer/products/swaggerproductpagewebsiteproductsml7signature-lined-blanket.png"].default
	},
	{
		title: "Afternoon Hoodie",
		src: imagesGlob["../../images/brands/marine-layer/products/swaggerproductpagewebsiteproductsml1afternoon-hoodie.png"].default
	},
	{
		title: "Corbet Full Zip Jacket",
		src: imagesGlob["../../images/brands/marine-layer/products/swaggerproductpagewebsiteproductsml2corbet-full-zip-jacket.png"].default
	},
	{
		title: "Corbet Quilted Crewneck",
		src: imagesGlob["../../images/brands/marine-layer/products/swaggerproductpagewebsiteproductsml4corbet-quilted-crewneck.png"].default
	},
	{
		title: "Sunset Pullover Hoodie",
		src: imagesGlob["../../images/brands/marine-layer/products/swaggerproductpagewebsiteproductsml8sunset-pullover-hoodie.png"].default
	}
]
</script>

<template lang="pug">
.page.page--brand.marine-layer
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/marine-layer/logo.png')
				h1 Custom Marine Layer
			.image
				img(src='@static/images/brands/marine-layer/hero.jpg' alt="Man and woman wearing Marine Layer apparel leaning against an old bus with the San Francisco Golden Gate Bridge in the background.")
	section.section.section--subhero
		.section__content
			.copy
				h3 Absurdly Soft Shirts
				p Marine Layer is beloved for their ridiculously soft tees and that effortless “7-day weekend” vibe we all crave. Born in San Francisco with a deep obsession for fabric innovation, they’ve crafted over 100 custom blends designed to feel like your favorite shirt from day one. From cozy tees to laid-back outerwear, Marine Layer delivers easygoing style without ever compromising on comfort or conscience.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src" :alt="`Custom Marine Layer ${product.title}`")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="marine-layer")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/marine-layer/banner.png' alt="Close-up of Marine Layer t-shirts with a tag highlighting the Re-Spun program that gives fabrics a second life by recycling materials")
			.section__content
				.copy
					h2 SOFT ON YOU. TOUGH ON WASTE.
					p The best part? That legendary softness doesn’t come at the planet’s expense. Marine Layer’s Re-Spun program keeps textiles out of landfills by turning recycled tees and fabrics into new ultra-soft yarn. That means no water, dyes, or chemicals needed. As a certified B Corp, they’re all about swag with style that’s as sustainable as it is soft. Bottom line: Marine Layer is proof that feel-good fashion can do good, too.
		
		section.section.section--foot
			.bg
			.section__content

</template>

<style></style>